import { PublicEventsSection } from '@/features/events/components/PublicEventsSection';
import type { SectionRendererProps } from '../section-renderer.types';

interface EventsTeaserContent {
  eyebrow?: string;
  title?: string;
  body?: string;
}

/**
 * Events section (FR-112, FR-123) - CMS owns only the eyebrow/title/intro;
 * the event cards themselves come from the existing public events API via
 * the shared `PublicEventsSection`, never from this section's own content
 * (FR-107).
 */
export function EventsTeaserRenderer({ section }: SectionRendererProps) {
  const c = section.content as unknown as EventsTeaserContent;
  return <PublicEventsSection eyebrow={c.eyebrow} title={c.title} intro={c.body} />;
}
